import {Text} from "@web-libs/ui/ui-components/typo/text";

export const FieldError = (props:{error?:string}) => {
    if(props.error){
       return <Text style={{marginTop:4}} block size={'xs'} color={'warn'}>{props.error}</Text>
    } else {
        return null
    }
}
